import axios from "axios";

// Global safety net: any 403 from the server sends the user to the login page,
// regardless of which component made the request. HashRouter listens for hash
// changes on window, so setting the hash directly navigates it without needing
// a shared history instance.
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 403) {
            window.location.hash = window.innerWidth < 768 ? "/loginMobile" : "/login";
        }
        return Promise.reject(error);
    }
);
